import { HomeSendMessageButton } from "features/homes/components/home.send-message.modal/home.send-message.button";
import { HomeSendMessageForm } from "features/homes/components/home.send-message.modal/home.send-message.form";

export const HomeSendMessageModal = {
    Button: HomeSendMessageButton,
    Component: HomeSendMessageForm,
}
